import { LegalDoc } from '@/components/LegalDoc';

export function UserAgreementPage() {
  return (
    <LegalDoc title="Пользовательское соглашение" effectiveFrom="01.01.2026">
      <p>
        Настоящее Пользовательское соглашение (далее — «Соглашение») регулирует отношения
        между администрацией проекта Empire of Life (далее — «Администрация») и любым физическим лицом
        (далее — «Пользователь»), посещающим сайт <strong>empire-life.ru</strong> и/или
        использующим Minecraft-сервер «Empire of Life» (далее — «Сервер»).
      </p>
      <p>
        Использование Сайта и/или Сервера означает безоговорочное согласие Пользователя
        с условиями настоящего Соглашения. Если Пользователь не согласен с условиями
        Соглашения, он обязан прекратить использование Сайта и Сервера.
      </p>

      <h2>1. Термины</h2>
      <ul>
        <li><strong>Сайт</strong> — интернет-ресурс, расположенный по адресу empire-life.ru.</li>
        <li><strong>Сервер</strong> — игровой сервер Minecraft проекта «Empire of Life».</li>
        <li><strong>Аккаунт</strong> — учётная запись, создаваемая Пользователем при авторизации через Discord.</li>
        <li><strong>Виртуальные товары</strong> — цифровые объекты (проходка, роли, предметы, наборы), приобретаемые на Сайте для использования на Сервере.</li>
        <li><strong>Внутренний баланс</strong> — учётная единица, отражающая права Пользователя на получение Виртуальных товаров.</li>
      </ul>

      <h2>2. Предмет Соглашения</h2>
      <p>
        Администрация предоставляет Пользователю доступ к Сайту и Серверу для развлечения,
        а также возможность приобретать Виртуальные товары. Доступ предоставляется на
        условиях «как есть».
      </p>

      <h2>3. Регистрация и аккаунт</h2>
      <ul>
        <li>Регистрация на Сайте осуществляется через OAuth2-авторизацию Discord. Пользователь подтверждает, что является владельцем используемого Discord-аккаунта.</li>
        <li>После авторизации Пользователь привязывает к своему аккаунту никнейм Minecraft. Привязка является окончательной — никнейм закрепляется за Discord-аккаунтом и не подлежит самостоятельному изменению.</li>
        <li>Использование одним лицом нескольких аккаунтов (мультиаккаунтинг) запрещено.</li>
        <li>Пользователь обязан соблюдать конфиденциальность доступа к своему Discord-аккаунту. Все действия, совершённые с его аккаунта, считаются совершёнными Пользователем лично.</li>
      </ul>

      <h2>4. Услуги Сервера и Виртуальные товары</h2>
      <ul>
        <li>Виртуальные товары имеют исключительно цифровую природу и не имеют материального воплощения.</li>
        <li>Право пользования Виртуальными товарами действует только в рамках Сервера и/или периода, указанного в описании товара.</li>
        <li>Виртуальные товары и Внутренний баланс не подлежат обмену на денежные средства, передаче третьим лицам и не имеют рыночной стоимости вне Сервера.</li>
        <li>Администрация вправе изменять состав, характеристики и стоимость Виртуальных товаров без предварительного уведомления.</li>
      </ul>

      <h2>5. Права и обязанности сторон</h2>
      <h3>5.1. Пользователь обязуется:</h3>
      <ul>
        <li>Соблюдать действующее законодательство Российской Федерации, условия настоящего Соглашения и Правила Сервера.</li>
        <li>Не использовать Сайт и Сервер для совершения противоправных действий, в том числе для распространения вредоносного программного обеспечения, спама, мошенничества.</li>
        <li>Не нарушать работоспособность Сайта и Сервера, не использовать читы, эксплойты, автоматизированные средства неправомерного доступа.</li>
        <li>Уважать других Пользователей и Администрацию.</li>
      </ul>
      <h3>5.2. Администрация вправе:</h3>
      <ul>
        <li>В любой момент изменять оформление и функциональность Сайта и Сервера, состав Виртуальных товаров.</li>
        <li>Ограничивать или прекращать доступ Пользователя к Сайту и Серверу в случае нарушения Соглашения или Правил Сервера без возврата уплаченных средств.</li>
        <li>Удалять, блокировать или модерировать пользовательский контент.</li>
        <li>Без предварительного уведомления проводить технические работы, приводящие к временной недоступности Сервера.</li>
      </ul>

      <h2>6. Стоимость и порядок оплаты</h2>
      <p>
        Подробное описание способов оплаты и порядка зачисления средств приведено в
        документе «Порядок проведения оплаты и безопасность». Подтверждая оплату,
        Пользователь подтверждает согласие с условиями данного Соглашения.
      </p>

      <h2>7. Возврат денежных средств</h2>
      <ul>
        <li>В соответствии с п. 4 статьи 26.1 Закона РФ «О защите прав потребителей» товар надлежащего качества, имеющий индивидуально-определённые свойства, возврату не подлежит.</li>
        <li>Виртуальные товары являются цифровыми услугами, оказываемыми мгновенно в момент покупки и считаются оказанными надлежащим образом с момента зачисления товара на аккаунт Пользователя.</li>
        <li>Денежные средства, переведённые на Внутренний баланс, возврату не подлежат.</li>
        <li>В исключительных случаях (техническая ошибка, ошибочное двойное списание, доказанный сбой системы) возврат возможен по решению Администрации после индивидуального рассмотрения обращения.</li>
      </ul>

      <h2>8. Ответственность</h2>
      <ul>
        <li>Администрация не несёт ответственности за невозможность использования Сайта или Сервера по причинам, не зависящим от Администрации (сбой провайдера, отключение электроэнергии, действия третьих лиц и т.п.).</li>
        <li>Администрация не возмещает упущенную выгоду Пользователя.</li>
        <li>Пользователь самостоятельно несёт ответственность за достоверность предоставленных при использовании Сайта сведений.</li>
      </ul>

      <h2>9. Интеллектуальная собственность</h2>
      <p>
        Все материалы Сайта (тексты, графика, оформление, программный код) являются объектом
        интеллектуальной собственности Администрации либо иных правообладателей, и охраняются
        в соответствии с законодательством Российской Федерации. Любое использование
        материалов без письменного согласия правообладателя запрещено.
      </p>
      <p>
        Minecraft является торговой маркой Mojang Studios / Microsoft. Проект «Empire of Life»
        не связан с Mojang, Microsoft или иными правообладателями игры Minecraft и не
        является официальным продуктом, спонсируемым ими.
      </p>

      <h2>10. Запрещённые действия</h2>
      <p>Пользователю запрещается:</p>
      <ul>
        <li>Использовать читы, эксплойты, неофициальные клиенты и иные средства, дающие неправомерное преимущество.</li>
        <li>Совершать действия, направленные на нарушение работы Сайта и Сервера (DDoS, перебор паролей и т.п.).</li>
        <li>Создавать и распространять копии Сайта и Сервера, использовать его в коммерческих целях без согласия Администрации.</li>
        <li>Перепродавать Виртуальные товары и Внутренний баланс третьим лицам.</li>
        <li>Размещать в чате и голосовом канале запрещённый контент: оскорбления, угрозы, призывы к насилию, материалы порнографического и экстремистского характера.</li>
      </ul>

      <h2>11. Персональные данные</h2>
      <p>
        Обработка персональных данных Пользователя осуществляется в соответствии с
        Федеральным законом № 152-ФЗ «О персональных данных» и описана в «Политике
        обработки персональных данных», размещённой на Сайте.
      </p>

      <h2>12. Изменение Соглашения</h2>
      <p>
        Администрация вправе в одностороннем порядке вносить изменения в Соглашение.
        Актуальная редакция всегда доступна на Сайте. Дата вступления изменений в силу
        указывается в начале документа. Продолжение использования Сайта после вступления
        изменений в силу означает согласие Пользователя с новой редакцией.
      </p>

      <h2>13. Прекращение действия</h2>
      <p>
        Соглашение действует с момента первого использования Сайта Пользователем и до
        полного прекращения такого использования. Администрация вправе расторгнуть
        Соглашение в одностороннем порядке в случае нарушения Пользователем его условий.
      </p>

      <h2>14. Применимое право и разрешение споров</h2>
      <p>
        К отношениям сторон применяется законодательство Российской Федерации. Споры
        разрешаются путём переговоров. При невозможности достижения согласия — в суде по
        месту нахождения Администрации в порядке, установленном законодательством РФ.
      </p>

      <h2>15. Контактная информация</h2>
      <ul>
        <li>Email: <a href="mailto:eol.servermc@gmail.com" className="text-eol-pink underline">eol.servermc@gmail.com</a></li>
        <li>Discord: <a href="https://discord.gg/KRfDxZDUfZ" target="_blank" rel="noreferrer" className="text-eol-pink underline">discord.gg/KRfDxZDUfZ</a></li>
      </ul>
    </LegalDoc>
  );
}
